var B = Object.defineProperty;
var V = (r, e, a) => e in r ? B(r, e, { enumerable: !0, configurable: !0, writable: !0, value: a }) : r[e] = a;
var d = (r, e, a) => V(r, typeof e != "symbol" ? e + "" : e, a);
import { observable as b, action as A, flow as j, makeObservable as k } from "mobx";
class J {
  constructor(e) {
    d(this, "agent");
    this.agent = e;
  }
  async fetchWells() {
    return (await this.agent.get("wells")).data;
  }
}
var F = /* @__PURE__ */ ((r) => (r[r.ACTIVE_GREEN = 0] = "ACTIVE_GREEN", r[r.ACTIVE_YELLOW = 1] = "ACTIVE_YELLOW", r[r.ACTIVE_RED = 2] = "ACTIVE_RED", r[r.COMPLETED = 3] = "COMPLETED", r))(F || {});
const R = [
  "Common_Pad",
  "Common_Rig",
  "Common_Brigade",
  "Common_Block",
  "Common_Field",
  "Common_Organization",
  "Common_Rig_Model"
];
function G(r, e) {
  const a = [], [s, n, l, m, c, W, z] = R.map(
    (t, i) => {
      var g, f, p, u, h, _, v, I, y, M, D, O, P, E;
      switch (t) {
        case "Common_Pad":
          return new Map(
            (f = (g = e[i]) == null ? void 0 : g.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? f : []
          );
        case "Common_Rig":
          return new Map(
            (u = (p = e[i]) == null ? void 0 : p.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? u : []
          );
        case "Common_Brigade":
          return new Map(
            (_ = (h = e[i]) == null ? void 0 : h.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? _ : []
          );
        case "Common_Rig_Model":
          return new Map(
            (I = (v = e[i]) == null ? void 0 : v.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? I : []
          );
        case "Common_Organization":
          return new Map(
            (M = (y = e[i]) == null ? void 0 : y.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? M : []
          );
        case "Common_Block":
          return new Map(
            (O = (D = e[i]) == null ? void 0 : D.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? O : []
          );
        case "Common_Field":
          return new Map(
            (E = (P = e[i]) == null ? void 0 : P.map((o) => [o.id, { id: o.id, ...o.data }])) != null ? E : []
          );
      }
    }
  );
  return r.forEach((t) => {
    const i = s.get(t.padId);
    i || console.error("cannot find pad fow well", t.id, t.name);
    const g = i ? c.get(i.fieldId) : void 0;
    g || console.error("cannot find field fow well", t.id, t.name);
    const f = i ? m.get(i.blockId) : void 0;
    f || console.error("cannot find block fow well", t.id, t.name);
    const p = n.get(t.rigId);
    p || console.error("cannot find rig fow well", t.id, t.name);
    const u = p ? z.get(p.modelId) : void 0;
    u || console.error("cannot find rigModel fow well", t.id, t.name);
    const h = l.get(t.brigadeId);
    h || console.error("cannot find brigade fow well", t.id, t.name);
    const _ = f ? W.get(f.organizationId) : void 0;
    _ || console.error("cannot find organization fow well", t.id, t.name), a.push({
      ...t,
      pad: i,
      field: g,
      block: f,
      rig: p,
      rigModel: u,
      brigade: h,
      organization: _
    });
  }), a;
}
async function N(r, e) {
  try {
    const [a, ...s] = await e.loadObjects([
      "GOdashboard_Well",
      ...R
    ]), n = (() => {
      const l = [], m = new Map(r.map((c) => [c.id, c]));
      return a == null || a.forEach((c) => {
        const W = m.get(c.id);
        W && l.push({
          ...W,
          ...c.data,
          createdAt: c.createdAt
        });
      }), l;
    })();
    return G(n, s);
  } catch (a) {
    return console.error(a), [];
  }
}
var Y = Object.defineProperty, X = Object.getOwnPropertyDescriptor, C = (r, e, a, s) => {
  for (var n = s > 1 ? void 0 : s ? X(e, a) : e, l = r.length - 1, m; l >= 0; l--)
    (m = r[l]) && (n = (s ? m(e, a, n) : m(n)) || n);
  return s && n && Y(e, a, n), n;
};
class w {
  constructor(e, a) {
    d(this, "api");
    d(this, "directoriesService");
    d(this, "allWells", []);
    d(this, "isLoading", !1);
    d(this, "error", null);
    d(this, "loadPromise", null);
    this.api = e, this.directoriesService = a, k(this);
  }
  getWellById(e) {
    return this.allWells.find((a) => a.id === e);
  }
  updateWellStatus(e, a) {
    const s = this.getWellById(e);
    if (!s) {
      console.error("cannot find corresponding well with wellId", e);
      return;
    }
    s.status = a;
  }
  async *load(e) {
    if (this.loadPromise && !(e != null && e.force)) {
      const n = await this.loadPromise;
      return yield, n;
    }
    this.isLoading = !0, this.error = null;
    const a = (async () => {
      try {
        const n = await this.api.fetchWells(), l = await N(n, this.directoriesService);
        return this.allWells = l, l;
      } catch (n) {
        return this.error = n, console.error(n), [];
      } finally {
        this.isLoading = !1, this.loadPromise = null;
      }
    })();
    this.loadPromise = a;
    const s = await a;
    return yield, s;
  }
}
C([
  b.ref
], w.prototype, "allWells", 2);
C([
  b
], w.prototype, "isLoading", 2);
C([
  b.ref
], w.prototype, "error", 2);
C([
  A.bound
], w.prototype, "updateWellStatus", 1);
C([
  j.bound
], w.prototype, "load", 1);
export {
  R as D,
  F as W,
  J as a,
  w as b,
  N as e
};
//# sourceMappingURL=wells-data-service-DlvEOcrX.js.map
